import React from 'react';
import {makeStyles} from '@mui/styles';
import {Grid} from '@mui/material';

import {Notifications} from './components';
import PageHeader from "../../../components/PageHeader/PageHeader";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    marginTop: 0
  }
}));

const NotificationSettings = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <PageHeader title={"Notifications"} subTitle={"Manage Notification Settings"}/>
      <Card  className={classes.content}>
        <CardBody>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              xs={12}
            >
              <Notifications />
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
};

export default NotificationSettings;
